import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { MatPaginator } from '@angular/material/paginator'
import { StatusInscricao } from 'src/app/models/status-inscricao'
import { StpgService } from 'src/app/services/stpg-service'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { DataService } from 'src/app/services/data-service'
import { UnespCoreUserService } from '@unesp/core'
import { UsuarioLogin } from 'src/app/models/usuario-login'

@Component({
  selector: 'app-stpg-status-inscricao',
  templateUrl: './stpg-status-inscricao.component.html',
  styleUrls: ['./stpg-status-inscricao.component.css'],
  standalone: false
})
export class StpgStatusInscricaoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  colunasGrid: string[] = ['detalhes', 'resumo']
  dataSource: MatTableDataSource<StatusInscricao> = new MatTableDataSource()

  anos: number[] = []
  anoSelecionado: number = 0
  idUnidadeUniversitaria: number = 0
  form = new FormGroup({
    cpf: new FormControl('', Validators.required),
  })

  constructor(
    private stpgService: StpgService,
    private dataService: DataService,
    private unespCoreUserService: UnespCoreUserService
  ) {}

  ngOnInit(): void {
    this.anos = this.dataService.listYearsSince2022()
    this.anoSelecionado = this.dataService.getCachedYearSince2022()
    this.unespCoreUserService.user$.subscribe(user => {
      this.idUnidadeUniversitaria = (user as UsuarioLogin).idUnidadeUniversitaria ?? 0
    })
  }

  getData(): void {
    this.dataService.setCachedYearSince2022(this.anoSelecionado)
    let cpf = this.form.controls['cpf'].getRawValue()
    if (cpf && cpf.length === 11) {
      this.stpgService.statusInscricao(this.idUnidadeUniversitaria, this.anoSelecionado, cpf).subscribe(data => {
        this.dataSource = new MatTableDataSource(data)
        this.dataSource.sort = this.sort
        this.dataSource.paginator = this.paginator
      })
    }
  }

  filtrar() {
    if (this.form.controls['cpf'].getRawValue()!.length === 11) {
      this.getData()
    }
  }

  scrollTo(element: any): void {
    ;(document.getElementById(element) as HTMLElement).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    })
  }
}
